import React, { useState, useEffect, useRef } from 'react';
import { MdClose } from "react-icons/md";
import { FaMagnifyingGlass } from "react-icons/fa6";

import GlobalContext from "../GlobalContext";

const FilterSearch = (props) => {
  const global = React.useContext(GlobalContext);
  const [searchValue, setSearchValue] = useState(props.queryParam ? props.queryParam : '');
  const timerRef = useRef(null);

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleClear = () => {
    setSearchValue('');
    global.actions.changeFilterQuery('');
  };

  useEffect(() => {
    if (searchValue.length >= 3 || searchValue.length === 0) {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        global.actions.changeFilterQuery(searchValue);
      }, 1000);
    }
  }, [searchValue, global.actions]);

  return (
    <div className='filter-search'>
      <FaMagnifyingGlass className='search-icon' />
      <input 
        onChange={handleChange}
        placeholder='Search'
        type='text'
        value={searchValue}
      />
      {searchValue && <MdClose className='clear' onClick={handleClear} />}
    </div>
  );
};

export default FilterSearch;